import React from 'react'
import { BrandListPageProps } from 'src/pages/BrandListPage/index'
import styled from 'styled-components'
import { Container } from 'src/components/common/Container'
import BrandListCategoryItems from 'src/pages/BrandListPage/_components/BrandListCategoryItems'
import BrandListChipsList from 'src/pages/BrandListPage/_components/BrandListChipsList'

const BrandListPageView = (props: BrandListPageProps) => {
  return (
    <S.BrandListContainer $option="flex_column">
      <BrandListChipsList {...props} />
      <BrandListCategoryItems {...props} />
    </S.BrandListContainer>
  )
}

export default BrandListPageView

const S = {
  BrandListContainer: styled(Container)`
    margin: 40px auto 0 auto;
  `,
}
